import i18n from '@/i18n';
import { TourStep } from '@/web-components/import-wizard-v2/typings/common';

export function tourStepsMapper(): TourStep[] {
  return [
    {
      target: '.ruler',
      header: {
        title: i18n.t('wizard-v2.tour.steps.step1-title').toString(),
      },
      content: i18n.t('wizard-v2.tour.steps.step1-description').toString(),
      offset: 200,
      params: {
        placement: 'left',
        index: 1,
        totalSteps: 6,
      },
    },
    {
      target: '#step2',
      header: {
        title: i18n.t('wizard-v2.tour.steps.step2-title').toString(),
      },
      content: i18n.t('wizard-v2.tour.steps.step2-description').toString(),
      offset: -200,
      params: {
        placement: 'right',
        index: 2,
        totalSteps: 6,
      },
    },
    {
      target: '#step3',
      header: {
        title: i18n.t('wizard-v2.tour.steps.step3-title').toString(),
      },
      content: i18n.t('wizard-v2.tour.steps.step3-description').toString(),
      offset: -200,
      params: {
        placement: 'left',
        index: 3,
        totalSteps: 6,
      },
    },
    {
      target: '#step4',
      header: {
        title: i18n.t('wizard-v2.tour.steps.step4-title').toString(),
      },
      content: i18n.t('wizard-v2.tour.steps.step4-description').toString(),
      params: {
        placement: 'left',
        index: 4,
        totalSteps: 6,
      },
    },
    {
      target: '#step5',
      header: {
        title: i18n.t('wizard-v2.tour.steps.step5-title').toString(),
      },
      content: i18n.t('wizard-v2.tour.steps.step5-description').toString(),
      params: {
        placement: 'top',
        index: 5,
        totalSteps: 6,
      },
    },
    {
      target: '#wizard-help',
      header: {
        title: i18n.t('wizard-v2.tour.steps.step6-title').toString(),
      },
      content: i18n.t('wizard-v2.tour.steps.step6-description').toString(),
      params: {
        placement: 'left',
        index: 6,
        totalSteps: 6,
      },
    },
  ];
}
